<template>
  <div>
    Display the objectives of the different scenarios. Those views are
    projections of the points of the Pareto front in 2D.

    <br />
    <br />

    The user can select which metric to place on each axis. The graph will then
    be displayed and the scenarios selected in comparator are highlighted.
  </div>
</template>

<script>
export default {
  name: 'tooltipParetoFrontViews'
}
</script>
